import { combineReducers } from 'redux'
import authSlice from './auth'

const quickApply = combineReducers({ auth: authSlice.reducer })

export default quickApply
